import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import SchoolModalForm from './SchoolModalForm';
import LoadingContainer from '../../common/LoadingContainer';
import { useSchoolStudent } from '../../../hooks/useBeneficiaries';

function EditSchoolModal({
  show,
  id,
  onSubmit,
  isSubmitLoading,
  onHide,
  title
}) {
  const { schoolStudent, isLoading } = useSchoolStudent(id);

  const formInitData = {};
  if (schoolStudent) {
    formInitData.school = schoolStudent.school_id;
    formInitData.startDate = schoolStudent.start_date;
    formInitData.endDate = schoolStudent.end_date;
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton className="modal-header">
        <Modal.Title className="modal-header-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pb-3 ps-3 pe-3">
        {isLoading ? (
          <LoadingContainer />
        ) : (
          <SchoolModalForm
            actionType="EDIT"
            initValues={formInitData}
            onSubmit={onSubmit}
            isSubmitLoading={isSubmitLoading}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}
EditSchoolModal.propTypes = {
  show: PropTypes.bool,
  id: PropTypes.string,
  onSubmit: PropTypes.func,
  isSubmitLoading: PropTypes.bool,
  onHide: PropTypes.func,
  title: PropTypes.string
};
export default EditSchoolModal;
